import moment from 'moment';
import React, { useState, useEffect } from 'react';
import Button from 'src/components/controls/forms/redesign/FormButton';
import EmployeeVacationBank from 'src/models/personnel/EmployeeVacationBank';
import TSDILandman from 'src/models/personnel/TSDILandman';
import useFetch from 'use-http';

interface IVacationBankPanelProps {
    selectedPersonnel: TSDILandman;
    closePanel: () => void;
}

const VacationBankPanel = (props: IVacationBankPanelProps) => {
    const [vacationBank, setVacationBank] = useState<Array<EmployeeVacationBank>>();
    const { get, response } = useFetch();

    useEffect(() => {
        updateVacationBank();
    }, [props.selectedPersonnel]);

    const updateVacationBank = async () => {
        let results = await get(`/v1.0/landmen/benefits/${props.selectedPersonnel?.tsdNo}/employee-vacation-bank`);

        if (response.ok) {
            results.forEach((res: EmployeeVacationBank) => {
                res.transactionDate = res.transactionDate ? (moment(res.transactionDate).format('MM-DD-YYYY') as unknown as Date) : null;
            });

            setVacationBank(results);
        } else {
            console.log('unable to fetch vacation bank for personnel');
        }
    };

    return (
        <div>
            <div
                style={{
                    borderBottom: '1px solid #ccc',
                    margin: '-.5rem -.5rem 1rem -.5rem',
                    background: '#EFF4F8',
                    display: 'flex',
                    justifyContent: 'left'
                }}
            >
                <h2 style={{ color: '#6393C1', padding: '.5rem 1rem', margin: '0' }}>
                    {`Vacation Bank ${props.selectedPersonnel ? 'for ' + props.selectedPersonnel.akaName : ''}`}
                </h2>
            </div>
            <div>
                <div style={{ overflowY: 'scroll', maxHeight: '55rem' }}>
                    <table style={{ width: '100%', tableLayout: 'auto' }}>
                        <thead>
                            <tr style={{ background: '#d6d6d6' }}>
                                <th className="sticky-header">Tran Date</th>
                                <th className="sticky-header">Tran Desc</th>
                                <th className="sticky-header">Period No</th>
                                <th className="sticky-header">Hours</th>
                                <th className="sticky-header">Type</th>
                                <th className="sticky-header">Type Description</th>
                                <th className="sticky-header">Tran Hrs</th>
                                <th className="sticky-header">I/O</th>
                                <th className="sticky-header">Timestamp</th>
                                <th className="sticky-header">Transaction By</th>
                                <th className="sticky-header">Running Total</th>
                            </tr>
                        </thead>
                        {vacationBank?.map((emp: EmployeeVacationBank, index: number) => {
                            return (
                                <tbody key={index}>
                                    <tr>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {emp?.transactionDate}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {emp?.transactionDescription}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {emp?.periodNumber}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {emp?.hours?.toFixed(2)}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {emp?.transactionType}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {emp?.transactionTypeDescription}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {emp?.transactionHours?.toFixed(2)}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {emp?.transactionDirection}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {emp?.timestamp}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {emp?.transactionBy}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {emp?.runningTotal.toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            );
                        })}
                    </table>
                </div>
            </div>
            <div className="button-row" style={{ paddingBottom: '1rem' }}>
                <Button text="Close" onClick={props.closePanel} intent="primary" />
            </div>
        </div>
    );
};

export default VacationBankPanel;


// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/benefits/VacationBankPanel.tsx